<template>
  <qx-card title="审核记录">
    <qx-img-dialog ref="imgDialog" />
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'proof'">
                <span v-for="(item,index) in scope.row.proofFiles" :key="index">
                  <img :src="getProofDisplayUrl(item)" style="width:100px;height:100px;cursor:pointer"
                       v-if="!isPdfFile(item)"
                       @click="previewImg(getProofDisplayUrl(item))"/>
                   <a
                       class="cur"
                       v-else
                       :href="getProofDisplayUrl(item)"
                       target="_blank"
                   >
                    <img style="width:100px;height:100px;cursor:pointer" src="~images/pdf-icon.png" />
                  </a>
                </span>
              </section>
              <section v-else>{{ scope.row[scope.column.property] }}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="tableData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import {getOrderMoneyTypeOperateRecordsByOrderId} from 'api/operate';
import {getFileUrl} from 'api';
import tableMixin from '@qx/mixin/table';
import imagePreview from '@qx/components/imagePreview';
import orderAuditProof from './orderAuditProof';

const {
  collectProofFlowIds,
  getProofDisplayUrl,
  getProofFiles,
  isPdfFile,
  refreshRecordProofUrls,
} = orderAuditProof;
const { buildImagePreviewState } = imagePreview;

/**
 * Query audit records and replace expired attachment URLs for display.
 * @param {Object} data audit-list query parameters
 * @returns {Promise<Object>} audit-list response
 */
async function getAuditRecordList (data) {
  const res = await getOrderMoneyTypeOperateRecordsByOrderId(data);
  if (!res || res.failed) {
    return res;
  }
  const pagination = res.pagination || {};
  const records = Array.isArray(res.items)
    ? res.items
    : (Array.isArray(res.rows)
      ? res.rows
      : (Array.isArray(pagination.items) ? pagination.items : []));
  const flowIds = collectProofFlowIds(records);
  let displayRecords = records;
  if (flowIds.length) {
    try {
      const fileResult = await getFileUrl({
        flowIds: flowIds.join(','),
        _GRID_TYPE: 'jq',
      });
      displayRecords = refreshRecordProofUrls(records, fileResult);
    } catch (err) {
      console.error('[auditLog] refresh proof urls failed:', err);
    }
  }
  const safeRecords = displayRecords.map((record) => ({
    ...record,
    proofFiles: getProofFiles(record.proof),
  }));
  records.splice(0, records.length, ...safeRecords);
  return res;
}

export default {
  mixins: [
    tableMixin,
  ],
  props: {
    orderId: {
      type: String,
    },
  },
  data () {
    return {
      searchBoxData: {
        orderId: '',
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'operateTime',
            label: '操作时间',
          },
          {
            prop: 'userName',
            label: '操作人',
          },
          {
            prop: 'auditingStatus',
            label: '操作记录',
          },
          {
            prop: 'moneyTypeName',
            label: '操作类型',
          },
          {
            prop: 'opinion',
            label: '操作内容',
            w: 200,
          },
          {
            prop: 'proof',
            label: '附件',
            w: 400,
          },

        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: getAuditRecordList,
    getProofDisplayUrl,
    isPdfFile,
    getAuditImageUrls () {
      const images = [];
      this.tableData.data.forEach((record) => {
        (record.proofFiles || []).forEach((file) => {
          if (!isPdfFile(file)) {
            images.push(getProofDisplayUrl(file));
          }
        });
      });
      return buildImagePreviewState('', images).urls;
    },
    previewImg (url) {
      this.$refs.imgDialog.show(url, this.getAuditImageUrls());
    },
  },
  created () {
    this.searchBoxData.orderId = this.orderId || this.$route.query.id;
    this.getData();
  },
};
</script>

<style scoped>

</style>
